/* 
  快捷键分发器
  web: 通过event监听鼠标键盘事件
  electron: 客户端通过c++插件监听电脑鼠标键盘事件，并直接在客户端读取本地设置判断触发的快捷键按键，通过electron传递事件web

  保存按下的按键数组，和setting_data中快捷键配置进行比对
  如果按下的按键包含快捷键则通过event bus进行分发

  如果要添加快捷键，理论上仅需要修改shortcut_config(web 和 客户端都需要改)

  为什么shortcut_config在web和客户端存两份: 监听快捷键的逻辑触发比较频繁，mouseKeyDeliver的逻辑写在客户端是为了给web减负。
*/

import store from "@/store";
import EventBus from './EventBus'
import { DEFAULT_SHORTCUT_CONGIF } from "@/common/constants/km-config"

class Shortcut {
  constructor() {
    // 给setting_data进行响应式绑定
    this.setting_data = {}
    Object.defineProperty(this, 'setting_data', {
      get: function() {
        return store.getters.setting_data
      },
      set: function(value) {
        store.dispatch("SET_SETTING_DATA_PARAM", value);
      }
    })
    this.preventSc = false
    this.pressKeys = []
    this.shortcut_config = []
    this.unrelease_key_config_list = []
    this.registerKeyMouseEvent()
  }
  registerKeyMouseEvent() {
    if (process.env.IS_CLIENT && window.electronAPI) {
      window.electronAPI.onKeyMouseEvent((_, t, b) => {
        this.handleBindKey(t, b)
      })
    } else {
      if (this._keyMouseDownEvent && this._keyMouseUpEvent) return
      this._keyMouseDownEvent = (e) => {this.mouseKeyDeliver(e, true)}
      this._keyMouseUpEvent = (e) => {this.mouseKeyDeliver(e, false)}
      window.addEventListener('keydown', this._keyMouseDownEvent)
      window.addEventListener('mousedown', this._keyMouseDownEvent)
      window.addEventListener('keyup', this._keyMouseUpEvent)
      window.addEventListener('mouseup', this._keyMouseUpEvent)
    }
  }
  mouseKeyDeliver(e, isDown) {
    if (this.preventSc) return
    let keyCode = e.button !== undefined ? e.button : e.keyCode
    if (isDown && this.pressKeys.includes(keyCode)) {
      return
    }
    if (isDown) {
      this.pressKeys.push(keyCode)
    } else {
      let i = this.pressKeys.indexOf(keyCode)
      if (i !== -1) {
        this.pressKeys.splice(i, 1)
      }
    }
    let down_types = [], up_types = []

    let real_shortcut_config = []
    // 处理语音包快捷键这种不定项的快捷键
    for (let c of this.shortcut_config) {
      let setting_obj = this.setting_data[c.key_config]
      // 判断是对象，对象形式字段是不定项的快捷键
      if (setting_obj && typeof setting_obj === 'object' && !Array.isArray(setting_obj)) {
        for (let key in setting_obj) {
          real_shortcut_config.push({
            key_config: c.key_config + '.' + key,
            addition_key: key
          })
        }
      } else {
        real_shortcut_config.push(c)
      }
    }
    for (let c of real_shortcut_config) {
      let checkList = [c.key_config, ...c.need_config || []]
      let pass = true
      checkList.forEach((v) => {
        if (!this.getSettingData(v)) pass = false
      })
      if (pass) {
        if (this.checkAllContains(this.getSettingData(c.key_config))) {
          down_types.push(c)
        } else {
          up_types.push(c)
        }
      } else {
        this[`${c.key_config}_lock`] = false
      }
    }

      // 未释放的快捷键不需要重复触发
      down_types = down_types.filter(({key_config}) => {
        return !this.unrelease_key_config_list.includes(key_config)
      })
      // 更新 未释放的快捷键
      down_types.forEach(({key_config}) => {
        this.unrelease_key_config_list.push(key_config)
      })
      
      up_types = up_types.filter(({key_config}) => {
        let index = this.unrelease_key_config_list.indexOf(key_config)
        if (index > -1) {
          this.unrelease_key_config_list.splice(index, 1)
        }
        return index > -1
      })

    for (let t of down_types) {
      this.handleBindKey(t, true)
    }
    for (let t of up_types) {
      this.handleBindKey(t, false)
    }
  }
  handleBindKey(c, isDown) {
    let type = c.key_config.split('.')[0]
    if (this[`${type}_lock`] === isDown) return
    this[`${type}_lock`] = isDown
    console.log('ShortCut_Deliver:'+type, isDown)
    if (c.deliver_key_up || isDown) {
      EventBus.$emit('ShortCut_Deliver:'+type, isDown, c.addition_key)
    }
  }
  checkAllContains(l2) {
    for (let k of l2) {
      if (!this.pressKeys.includes(k)) {
        return false
      }
    }
    return true
  }
  getSettingData(key) {
    let keys = key.split('.')
    let result = this.setting_data
    try {
      keys.forEach((k) => {
        result = result[k]
      })
      return result
    } catch (e) {
      return null
    }
  }
  preventShorcut(v) {
    this.preventSc = v
    if (process.env.IS_CLIENT) {
      window.electronAPI.setKeyMousePrevent(v)
    }
  }
  addShortcut (config, callback) {
    this.shortcut_config.push({
      ...DEFAULT_SHORTCUT_CONGIF,
      ...config,
      callback
    })
    if (process.env.IS_CLIENT) {
      window.electronAPI.addKMShortcut({
        ...DEFAULT_SHORTCUT_CONGIF,
        ...config
      })
    }
    if(callback && callback instanceof Function) EventBus.$on('ShortCut_Deliver:' + config.key_config, callback)
  }
  removeShortcut (key_config) {
    let key = this.shortcut_config.find(item => item.key_config === key_config)
    this.shortcut_config.splice(this.shortcut_config.indexOf(key), 1)
    if (process.env.IS_CLIENT) {
      window.electronAPI.removeKMShortcut(key_config)
    }
    if(key.callback && key.callback instanceof Function) EventBus.$off('ShortCut_Deliver:' + key_config, key.callback)
  }
}

const shortcut = new Shortcut();

export default shortcut;